import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../../Languages/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllDeliveryRequests } from "../../../features/dashboard/newBuilderSlice";
import NewPagination from "./Pagination/NewPagination";
import AssignPersonModal from "../Modals/AssignPersonModal";

const DeliveryRequest = () => {
  const { t } = useContext(LanguageContext);

  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [limit] = useState(10);
  const [showAssignModal, setShowAssignModal] = useState(false);

  const { deliveryRequests, loading, error } = useSelector(
    (state) => state.dashboard || {}
  );

  const handleAdd = (id) => {
    setSelectedRequestId(id);
    setShowAssignModal(true);
  };

  useEffect(() => {
    dispatch(fetchAllDeliveryRequests({ page, limit }));
  }, [dispatch, page, limit]);

  const handleReload = () => {
    dispatch(fetchAllDeliveryRequests({ page, limit }));
  };

  const requests = deliveryRequests?.data || [];
  const pagination = deliveryRequests?.pagination || { total_pages: 1 };

  return (
    <div className="d-flex flex-column container-fluid justify-content-between mb-4">
      <div>
        <div className="d-flex justify-content-between">
          <div className="text-left fw-bold mb-3 fs-4 text-light">
            {t?.deliveryrequest || "Delivery Request"}
          </div>
          <div
            className="btn btn-sm btn-light d-flex justify-content-center align-items-center text-white"
            style={{ cursor: "pointer", width: "35px", height: "35px" }}
            onClick={handleReload}
          >
            <i className="bi bi-arrow-clockwise fs-5"></i>
          </div>
        </div>
        {loading && !showAssignModal && (
          <div className="text-center text-warning fw-bold">
            Loading delivery requests...
          </div>
        )}

        {error && (
          <div className="text-center text-danger fw-bold">Error: {error}</div>
        )}

        {(!loading || showAssignModal) && !error && (
          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle text-center text-info">
              <thead className="table-light">
                <tr>
                  <th className="text-info">Date</th>
                  <th className="text-info">Status</th>
                  <th className="text-info">Name</th>
                  <th className="text-info">Email</th>
                  <th className="text-info">Phone</th>
                  <th className="text-info">Customer Address</th>
                  <th className="text-info">Store Address</th>
                  <th className="text-info">Delivery Fee</th>
                  <th className="text-info">Actions</th>
                </tr>
              </thead>
              <tbody>
                {requests.length > 0 ? (
                  requests.map((request) => (
                    <React.Fragment key={request.id}>
                      <tr style={{ cursor: "pointer" }}>
                        <td style={{ fontSize: "14px" }}>
                          {new Date(request.created_at)
                            .toISOString()
                            .slice(0, 10)}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          <span
                            style={{
                              color:
                                request.status === "complete"
                                  ? "green"
                                  : request.status === "pending"
                                  ? "orange"
                                  : "red",
                            }}
                          >
                            {request.status || "N/A"}
                          </span>
                        </td>
                        <td style={{ fontSize: "14px" }}>{request.customer_name || "N/A"}</td>
                        <td style={{ fontSize: "14px" }}>{request.customer_email || "N/A"}</td>
                        <td style={{ fontSize: "14px" }}>{request.customer_phone || "N/A"}</td>
                        <td style={{ fontSize: "14px" }}>
                          {request.customer_address || "N/A"}
                        </td>
                        <td style={{ fontSize: "14px" }}>
                          {request.store_address || "N/A"}
                        </td>
                        <td style={{ fontSize: "14px" }}>ETB {request.delivery_fee || "N/A"}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleAdd(request.id)}
                            style={{ fontSize: "14px" }}
                          >
                            Accept & Assign
                          </button>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center text-muted">
                      No Delivery Requests found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {!loading && !error && (
        <NewPagination
          page={pagination.page || page}
          totalPages={pagination.total_pages || 1}
          setPage={setPage}
        />
      )}

      <AssignPersonModal
        show={showAssignModal}
        onClose={() => setShowAssignModal(false)}
        deliveryRequestId={selectedRequestId}

        // onSave={handleSave}
      />
    </div>
  );
};

export default DeliveryRequest;
